import { createVanIconComponent } from "./van"

const SmileComment = createVanIconComponent("smile-comment")
export default SmileComment
